export class FailedToDetermineItemsToSyncError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "FailedToDetermineItemsToSyncError"
    }
}
